import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseUrls } from '../appConstant';

@Injectable()
export class UserDashboardService {

  userToken = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : '';
  constructor(private httpClient: HttpClient) { }

  userRecommendedData(): Observable<any>{
    let url = baseUrls['bill'] + 'digitalservice/recommendation';
    return this.httpClient.get(url,  {headers: { 'token': this.userToken}});
  }
  userOverViewdData(): Observable<any>{
    let url = baseUrls['bill'] + 'digitalservice/stats/user';
    return this.httpClient.get(url,  {headers: { 'token': this.userToken}});
  }
  userPlaylistData(startPassed, lengthPassed): Observable<any>{
    let url = baseUrls['bill'] + `digitalservice/playlist?start=${startPassed}&length=${lengthPassed}`;
    return this.httpClient.get(url,  {headers: { Token: this.userToken}});
  }

  getSchedules(){
    const url = baseUrls['bill'] + 'userservice/schedules/list';
    return this.httpClient.get(url,  {headers: { Token: this.userToken}});
  }

  getRecommendedTrips(userIdPassed){
    const url = baseUrls['base'] + 'program/listing/recommended';
    return this.httpClient.post(url, {userId: userIdPassed});
  }

  public getRound(val) {
    return val?val.toFixed(1):'';
  }
}
